import $ from 'jquery';

const $body = $('body');
const $cookienote = $('.cookienote');

/**
 * @param  {String} cname cookie name
 * @return {String} cookie name or empty string
 */
function getCookie(cname) {
  const name = `${cname}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

/**
 * @param  {String} cname cookie name
 * @param  {String} cvalue cookie value
 * @param  {Number} exdays days until cookie expires
 * @return {void}
 */
function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  const expires = `expires=${d.toUTCString()}`;
  document.cookie = `${cname}=${cvalue};expires=${expires};path=/`;
  return true;
}

if (getCookie('obo_cookienote_confirm') !== '1') {
  $body.addClass('show-cookienote');
}

$('.cookienote-confirm').on('click', () => {
  if (setCookie('obo_cookienote_confirm', 1, 365)) {
    $cookienote.fadeOut();
    $body.removeClass('show-cookienote');
  }
});



// WEBPACK FOOTER //
// ./assets/js/components/cookienotice.js